//引入全域註冊用的組件
import Popup from '@/components/global/Popup.vue';
import PopupSuccess from '@/components/global/PopupSuccess.vue';
import PopupError from '@/components/global/PopupError.vue';
import PopupCheck from '@/components/global/PopupCheck.vue';
import PopupText from '@/components/global/PopupText.vue';
import MyTransition from '@/components/global/MyTransition.vue'
import Loading from '@/components/global/Loading.vue'


const plugins={
  //執行註冊(全域元件)
  install(Vue,option){
    Vue.component('Popup',Popup);
    Vue.component('PopupSuccess',PopupSuccess);
    Vue.component('PopupError',PopupError);
    Vue.component('PopupCheck',PopupCheck);
    Vue.component('PopupText',PopupText);
    Vue.component('MyTransition',MyTransition);
    Vue.component('Loading',Loading);
  }
}

export default plugins
